import ReactMarkdown from 'react-markdown';

import { i18n } from '../../lib/lang';
import styled from 'styled-components';
import { COLOR_ENUM } from '../../theme/color';

export const MarkDown = ({ tid, theme }: any) => {
  const components = {
    a: ({ href, children }: any) => (
      <LinkStyled href={href} target="_blank" rel="noopener noreferrer">
        {children}
      </LinkStyled>
    ),
    img: ({ src, alt }: { src?: string; alt?: string }) => (
      <Img src={src} alt={alt} />
    ),
  };

  const markdownContent = i18n.t(tid);

  return (
    <div>
      <ReactMarkdownStyled components={components}>
        {markdownContent}
      </ReactMarkdownStyled>
    </div>
  );
};

const ReactMarkdownStyled = styled(ReactMarkdown)`
  span,
  li,
  p {
    margin: unset !important;
    font-size: 13px !important;
    line-height: 1.7em !important;
    max-width: 90%;
    color: ${({ theme }) => theme[COLOR_ENUM.WHITE]};
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${({ theme }) => theme[COLOR_ENUM.WHITE]};
  }
`;

const LinkStyled = styled.a`
  color: ${({ theme }) => theme[COLOR_ENUM.DEFAULT]} !important;
`;

const Img = styled.img`
  max-width: 100%;
  height: auto;
  max-height: 300px;
  border-radius: 12px;
  object-fit: contain;
  margin: 0 auto;
  display: block;
`;
